import { __decorate, __metadata } from "tslib";
import { ObservableValue } from '../../Model/ObservableValue';
import { Notification } from './Notification';
import { Observable } from '../../Model/Decorators';
import NeoModel from '../../Model/NeoModel';
import { injectable } from 'inversify';
var NotificationStore = /** @class */ (function () {
    function NotificationStore() {
        this.notifications = [];
    }
    NotificationStore.prototype.onHidden = function (notification) {
        var index = this.notifications.indexOf(notification);
        if (index >= 0) {
            this.notifications.splice(index, 1);
        }
    };
    /**
     * Adds a notification to the notification list
     * @param heading Text to show in the header
     * @param body Text or component to show in the body
     * @param variant Bootstrap variant
     * @param autoHideTimeSeconds Number of seconds to wait before auto hiding the notification. The notification wont automatically close if this is unspecified.
     */
    NotificationStore.prototype.add = function (heading, body, variant, autoHideTimeSeconds) {
        var notification = new Notification({
            heading: heading,
            bindShow: new ObservableValue(true),
            animateInitial: true,
            variant: variant,
            autoCloseTimeout: autoHideTimeSeconds && autoHideTimeSeconds * 1000,
            onHidden: this.onHidden.bind(this)
        }, body);
        this.notifications.splice(0, 0, notification);
        return notification;
    };
    /**
     * Adds a notification to the notification list if the specified key is not already in the list.
     * @param key Unique key for this type of notification
     * @param heading Text to show in the header
     * @param body Text or component to show in the body
     * @param variant Bootstrap variant
     * @param autoHideTimeSeconds Number of seconds to wait before auto hiding the notification. The notification wont automatically close if this is unspecified.
     */
    NotificationStore.prototype.addOrUpdate = function (key, heading, body, variant, autoHideTimeSeconds) {
        var found = this.notifications.find(function (n) { return n.key === key; });
        if (found) {
            found.options.heading = heading;
            found.options.variant = variant;
            found.options.autoCloseTimeout = autoHideTimeSeconds && autoHideTimeSeconds * 1000;
            found.body = body;
            found.refreshValue += 1;
        }
        else {
            found = this.add(heading, body, variant, autoHideTimeSeconds);
            found.key = key;
        }
        return found;
    };
    /**
     * Hides a notification that was added with the specified key.
     * @param key Unique key for this type of notification
     */
    NotificationStore.prototype.remove = function (key) {
        var found = this.notifications.find(function (n) { return n.key === key; });
        if (found) {
            found.hide();
        }
    };
    __decorate([
        Observable(),
        __metadata("design:type", Array)
    ], NotificationStore.prototype, "notifications", void 0);
    NotificationStore = __decorate([
        injectable(),
        NeoModel
    ], NotificationStore);
    return NotificationStore;
}());
export { NotificationStore };
